module.exports = __webpack_public_path__ + "static/img/2_1_6.af121d7c.jpg";